
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/neat-vs-fyle",
      function () {
        return require("private-next-pages/neat-vs-fyle.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/neat-vs-fyle"])
      });
    }
  